import { IPlacementDataTable } from "../modules/sponsoredProductsSKCAntd/types/placement"
import { placementsEnum } from "../modules/sponsoredProductsSKCAntd/types/types"
import { ICalcBestCPC, ICalcLimitedCPC } from "../types/metrics.types"
import { applyBidChangeLimits, calcTargetCPC, minMaxValidation } from "./helpers/metrics.helper"

interface IDeterminePercentageProps {
  TOSPercentage: number
  PPPercentage: number
  ROSPercentage: number
  ABPercentage: number
  ADPercentage: number
}

export const useMetrics = () => {
  function calcLimitedCPC(params: ICalcLimitedCPC): number {
    const {
      defaultBid,
      clicks,
      conditions,
      currentAcos,
      targetAcos,
      orders,
      impressions,
      aovValue,
      bidInAmazon,
      sales,
      minLimitedCPC,
      percentage,
      minTargetCPC,
      maxTargetCPC,
    } = params

    if (!bidInAmazon) {
      return defaultBid
    }

    if (orders === 0 && clicks < 4 && percentage && minLimitedCPC) {
      const limitedCPC = minLimitedCPC * (1 + percentage / 100)
      return minMaxValidation(limitedCPC, minTargetCPC, maxTargetCPC)
    }

    if (clicks < 4 && defaultBid >= bidInAmazon) {
      return defaultBid
    }
    if (clicks < 4 && defaultBid < bidInAmazon) {
      return bidInAmazon
    }

    const targetCPC = calcTargetCPC({
      targetAcos,
      orders,
      impressions,
      aovValue,
      clicks,
      bidInAmazon,
      currentAcos,
      sales,
      defaultBid,
    })

    return applyBidChangeLimits({
      bidInAmazon,
      targetCPC,
      currentAcos,
      conditions,
      minTargetCPC,
      maxTargetCPC,
    })
  }

  function calcBestCPC(params: ICalcBestCPC): number {
    const { targetCVRCPC, targetCPC, bestCVRCPC } = params
    return targetCVRCPC === 1
      ? Number(targetCPC?.toFixed(2) || 0)
      : Number(bestCVRCPC?.toFixed(2) || 0)
  }

  function determinePercentage(
    placement: IPlacementDataTable,
    {
      TOSPercentage,
      PPPercentage,
      ROSPercentage,
      ABPercentage,
      ADPercentage,
    }: IDeterminePercentageProps
  ) {
    if (placement.placement === placementsEnum.TOP_OF_SEARCH) {
      return TOSPercentage
    }

    if (placement.placement === placementsEnum.PRODUCT_PAGE) {
      return PPPercentage
    }

    if (placement.placement === placementsEnum.REST_OF_SEARCH) {
      return ROSPercentage
    }

    if (placement.placement === placementsEnum.AMAZON_BUSINESS) {
      return ABPercentage
    }

    if (placement.placement === placementsEnum.AUDIENCE) {
      return ADPercentage
    }

    return 0
  }

  return {
    calcLimitedCPC,
    calcTargetCPC,
    calcBestCPC,
    determinePercentage,
  }
}

export default useMetrics
